import Errors from './Errors';
import { apiVersion } from './main.js';
import { resolveApiBase } from './shared/utils/resolveApiBase';

class Form {
    /**
     * Create a new Form instance.
     *
     * @param {object} data
     */
    constructor(data) {
        this.originalData = data;

        for (let field in data) {
            this[field] = data[field];
        }

        this.errors = new Errors();
        this.retorno = {};
    }


    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        for (let property in this.originalData) {
            data[property] = this[property];
        }

        return data;
    }


    /**
     * Reset the form fields.
     */
    reset() {
        for (let field in this.originalData) {
            this[field] = '';
        }

        this.errors.clear();
    }
    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url) {
        return this.submit('post', resolveApiBase(apiVersion()) + url);
    }
    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    get(url) {
        try {
            return this.submit('get', resolveApiBase(apiVersion()) + url);
        } catch (teste) {
            return this.submit('get', resolveApiBase(1) + url);
        }
    }

    /**
     * Send a PUT request to the given URL.
     * .
     * @param {string} url
     */
    put(url) {
        return this.submit('put', resolveApiBase(apiVersion()) + url);
    }


    /**
     * Send a PATCH request to the given URL.
     * .
     * @param {string} url
     */
    patch(url) {
        return this.submit('patch', resolveApiBase(apiVersion()) + url);
    }


    /**
     * Send a DELETE request to the given URL.
     * .
     * @param {string} url
     */
    delete(url) {
        return this.submit('delete', resolveApiBase(apiVersion()) + url);
    }


    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        return new Promise((resolve, reject) => {
            axios[requestType](url, this.data(), {
                timeout: 300000,
                maxContentLength: 10 * 1024 * 1024,
                withCredentials: true,
            })
                .then(response => {

                    this.onSuccess(response.data);
                    // Retorna o http status

                    if (response.status != 204) {
                        response.data.httpStatus = response.status;
                    }
                    resolve(response.data);
                })
                .catch(error => {
                    // 401: axios interceptor tenta refresh via /api/usuario; fallback abaixo.
                    if (error.response && error.response.status == 401) {
                        if (typeof window.forceSessionExpired === 'function') {
                            window.forceSessionExpired();
                        }
                    }

                    // Falha sem resposta (rede/timeout): rejeita com o próprio erro
                    // em vez de estourar TypeError e deixar a promise pendente.
                    if (!error.response) {
                        reject(error);
                        return;
                    }

                    if (error.response.data && error.response.data.type == 3) {
                        this.onFail(error.response.data);

                        reject(error.response.data.errors);
                    }
                    else {
                        reject(error.response.data);
                    }

                });
        });
    }


    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        //this.reset();
    }


    /**
     * Handle a failed form submission.
     *
     * Ponto de extensao: ha view que sobrescreve `onFail` na instancia para
     * notificar o usuario, porque `submit` descarta a `message` do envelope
     * quando `type == 3`. Grepe por OVERRIDE-FORM-ONFAIL antes de mudar este
     * metodo — passar a notificar aqui geraria mensagem duplicada la.
     *
     * @param {object} errors
     */
    onFail(errors) {
        this.errors.record(errors.errors, errors.message, errors.type);
    }
}


export default Form;
